import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

const ExpansionOrden: React.FC<{ data: any }> = ({ data = {} }) => {

    const fechaTabla = (rowData: any) => {
        const fecha = new Date(rowData.fechaHora);
        return <div>{`${fecha.toLocaleDateString()} ${fecha.toLocaleTimeString()}`}</div>
    }

    const tablaEstados = (estados: any) => (
        <DataTable value={estados} style={{ width: '90%', marginLeft: '5%' }}
            header='Estados de la orden' >
            <Column field="fechaHora" header="Fecha y hora" filter={true}
                body={fechaTabla} />
            <Column field="nombre" header="Nombre" filter={true} />
        </DataTable>
    )

    return <>
        <div className="p-grid">
            <div className="p-col-12 p-md-3 p-lg-3 "
                style={{ fontWeight: 'bold' }}>
                Tipo de Vehículo:
            </div>
            <div className="p-col-12 p-md-3 p-lg-3 ">
                {data.vehiculo.tipoVehiculo.nombre}
            </div>
            <div className="p-col-12 p-md-3 p-lg-3 "
                style={{ fontWeight: 'bold' }}>
                Servicios:
            </div>
            <div className="p-col-12 p-md-3 p-lg-3 "
                style={{ textAlign: 'left' }}>
                {
                    data.servicios.map((serv: any) => (
                        <li>{serv.nombre}</li>
                    ))
                }
            </div>
            {
                data.observaciones ?
                    <div className='p-grid p-col-12'>
                        <div className="p-col-12 p-md-3 p-lg-3"
                            style={{ fontWeight: 'bold' }}>
                            Observaciones:
                        </div>
                        <div className="p-col-12 p-md-9 p-lg-9">
                            {data.observaciones}
                        </div>
                    </div>
                    : null
            }
            {
                data.cliente ?
                    <div className='p-grid p-col-12' style={{ textAlign: 'left' }}>
                        <div className='p-col-12 tituloDetalles'>
                            DATOS DEL CLIENTE
                        </div>
                        <div className="p-col-12 p-md-3 p-lg-3"
                            style={{ fontWeight: 'bold' }}>
                            Nombres y Apellidos:
                        </div>
                        <div className="p-col-12 p-md-3 p-lg-3">
                            {data.cliente.nombresApellidos}
                        </div>
                        <div className="p-col-12 p-md-3 p-lg-3"
                            style={{ fontWeight: 'bold' }}>
                            Correo electrónico:
                        </div>
                        <div className="p-col-12 p-md-3 p-lg-3">
                            {data.cliente.correo}
                        </div>
                        <div className="p-col-12 p-md-3 p-lg-3"
                            style={{ fontWeight: 'bold' }}>
                            Teléfono:
                        </div>
                        <div className="p-col-12 p-md-3 p-lg-3">
                            {data.cliente.telefonoMovil}
                        </div>
                    </div>
                    : null
            }
            {
                data.elementosValor && data.elementosValor.length > 0 ?
                    <div className='p-grid p-col-12' style={{ textAlign: 'left' }}>
                        <div className='p-col-12 tituloDetalles'>
                            ELEMENTOS DE VALOR
                        </div>
                        <div className="p-col-12 p-md-3 p-lg-3 "
                            style={{ textAlign: 'left', marginLeft: 50 }}>
                            {
                                data.elementosValor.map((elem: any) => (
                                    <li>{elem.nombre}</li>
                                ))
                            }
                        </div>
                    </div>
                    : null
            }
            {tablaEstados(data.estados)}
        </div>
    </>
}

export default ExpansionOrden;